import knAxios, { knAuthAxios } from "@/lib/kn-axios";

const DepParentsRemoteDataSource = {
  getParentData: async (uuid) => {
    const { data } = await knAuthAxios.get(`api-key/users/${uuid}`);
    return data;
  },

  getRelativeTutorData: async (uuid) => {
    const { data } = await knAxios.get(`relatives/tutor/${uuid}`);
    return data;
  },

  getShipmentData: async (idRelative) => {
    const { data } = await knAxios.get(
      `shipmentInformation/getShipmentInfoByIdRelative/${idRelative}`
    );
    return data;
  },

  getInvoiceData: async (idRelative) => {
    const { data } = await knAxios.get(`invoiceInfos/tutorInfo/${idRelative}`);
    return data;
  },

  getAssociationData: async (idRelative) => {
    const { data } = await knAxios.get(
      `userRelatives/getByUUIDRelative/${idRelative}`
    );
    return data;
  },

  getSchoolAssociationData: async (idCity, idState, name) => {
    const { data } = await knAxios.get(
      `campus/getCampus/city/${idCity}/state/${idState}`,
      { params: { name: name } }
    );
    return data;
  },

  saveUserInfo: async (request) => {
    const { data } = await knAuthAxios.post("api-key/users", request);
    return data;
  },

  saveInvoiceInfo: async (request) => {
    const { data } = await knAxios.post("/invoiceInfos/save", request);
    return data;
  },

  setNotInvoiceInfo: async (idUser) => {
    return knAxios.post(`/relatives/updateInvoiceRequired/${idUser}`);
  },

  saveShippingInfo: async (request) => {
    const { data } = await knAxios.post("/shipmentInformation/save", request);
    return data;
  },

  saveAssociationDataInfo: async (request, idRelative) => {
    const { data } = await knAxios.post(
      `/userRelatives/tutor/${idRelative}`,
      request
    );
    return data;
  },

  searchStudentByCurpOrUsername: async (idCampusInt, curpOrUsername) => {
    const { data } = await knAxios.post("/users/getUser", [idCampusInt], {
      params: { curpOrUserName: curpOrUsername },
    });
    return data;
  },

  getStudentCurpInfo: async (request, curpOrUserName) => {
    // TODO(Jordy): remove this method
    const { data } = await knAxios.post("/users/getUser", request, {
      params: { curpOrUserName: curpOrUserName },
    });
    return data;
  },

  getPaymentStudentInfo: async (idPayment) => {
    return await knAxios
      .get(`/payments/balance/getInfoPerPay/${idPayment}`)
      .then((res) => res.data);
  },

  getRelationshipsInfo: async () => {
    const { data } = await knAxios.get("/relationships");
    return data;
  },

  getGenerateInvoiceInfo: async (idPayment) => {
    const { data } = await knAxios.get(
      `/invoices/generateInvoice/${idPayment}`
    );
    return data;
  },

  getIsProfileCompleted: async (userId) => {
    const { data } = await knAxios.get(`/users/is-completed/${userId}`);
    return data;
  },

  getIsInvoiceProfileCompleted: async (userId) => {
    const { data } = await knAxios.get(`/invoiceInfos/is-completed/${userId}`);
    return data;
  },

  getUserData: async (userId) => {
    const { data } = await knAxios.get(`/users/${userId}`);
    return data;
  },

  updateUserProfile: async (request) => {
    const { data } = await knAxios.post("/users", request);
    return data;
  },

  validateBbva: async (bin) => {
    return await knAxios.get(`/payments/bin-card/${bin}/is-bbva`);
  },
};

export default DepParentsRemoteDataSource;
